import ideateIcon from '../assets/statsAndProcess/ideate.svg';
import developIcon from '../assets/statsAndProcess/develop.svg';
import maintainIcon from '../assets/statsAndProcess/maintain.svg';
import scaleIcon from '../assets/statsAndProcess/scale.svg';

export const configProcess = [
  {
    id: 'ideate',
    title: 'Ideate',
    description:
      'We collaborate with clients to define goals, explore ideas, and create a clear plan for a successful software solution.',
    icon: ideateIcon,
    alt: 'Ideate',
  },
  {
    id: 'develop',
    title: 'Develop',
    description:
      'Our team builds robust, scalable applications using modern technologies and best development practices.',
    icon: developIcon,
    alt: 'Develop',
  },
  {
    id: 'maintain',
    title: 'Maintain',
    description:
      'We provide ongoing support, updates, and optimizations to ensure your software remains reliable and efficient.',
    icon: maintainIcon,
    alt: 'Maintain',
  },
  {
    id: 'scale',
    title: 'Scale',
    description:
      'We help your solution grow with your business by enhancing performance, adding features, and supporting larger user bases.',
    icon: scaleIcon,
    alt: 'Scale',
  },
];
